import React, {useEffect, useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import arrowLeft from "../../assets/icon/arrow-back.svg";
import settingIcon from "../../assets/images/settingIcon.svg";
import { Button, Box, IconButton, Typography, Avatar, Tooltip } from "@mui/material";
import { useNavigate } from "react-router";
import {getUserDetails, removeUser} from "../../store/auth";
import { MdPowerSettingsNew } from "react-icons/md";
import { confirmation } from "../../services/utills";
import MenuIcon from "@mui/icons-material/Menu";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import {getClinicByID} from "../../store/clinics";
import setting from "../../assets/icon/settings.svg"    
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import AdminDrawer from "../siderbar/adminDrawer";
import SettingsIcon from '@mui/icons-material/Settings';
import WavingHandIcon from '@mui/icons-material/WavingHand';
import {apiHeaders} from "../../lib/apiHeader";
import Pusher from "pusher-js";
import { BACKEND_URL } from "../../config";
import NotificationsBell from "../crm-dashboard/NotificationsBell";
import { EventReportDashboard } from "../../store/crm/dashboard";

const Header = ({ 
                    isCRM,
                    admin,   
                    sidebarOpen,  
                    mobileOpen,    
                    setSidebarOpen,
                    setMobileOpen,
}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch(); 
    const [clinicLoading, setClinicLoading] = useState(false)
    const [loading, setLoading] = useState(false)

    const user = useSelector((state) => state?.authStore?.user);
    // Notifications bell data — reuse the CRM dashboard "Upcoming Events" API
    const Event_report = useSelector((state) => state?.crmDashboardStore?.Event_report);
   //console.log("user",user)

    // Fetch upcoming events for the notifications bell (CRM context only)
    useEffect(() => {
        if (isCRM && user?.id) {
            dispatch(EventReportDashboard());
        }
    }, [isCRM, user?.id, dispatch]);
    const handleLogout = async () => {
        if (!await confirmation("Are you sure you want to logout?", "Yes, Logout!")) {
            return;
        }

        try {
            setClinicLoading(true);

            // 1. Call Laravel logout API with proper string interpolation
            const response = await fetch(`${BACKEND_URL}logout`, {  // Use backticks for template literal
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...apiHeaders(),
                },
            });

            if (!response.ok) {
                throw new Error('Logout failed');
            }

            // 2. Clear client-side storage
            localStorage.removeItem('token');
            dispatch(removeUser());

            // 3. Clear all cookies (for subdomains)
            const domainsToClear = [
                window.location.hostname,
                '.3dlifestyle.ca', // Covers all subdomains
            ];

            domainsToClear.forEach(domain => {
                document.cookie.split(';').forEach(cookie => {
                    const name = cookie.trim().split('=')[0];
                    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${domain}`;
                });
            });
            setClinicLoading(false)
            // 4. Redirect to login
            const loginUrl = window.location.hostname.includes('localhost')
                ? 'http://localhost:3000/login'
                : `https://${window.location.hostname.replace(/^[^.]+/, 'app')}.3dlifestyle.ca/login`;

            window.location.href = '/login';

        } catch (error) {

            console.error('Logout error:', error);
            // Fallback: Force redirect even if API fails
            window.location.href = '/login';
        }
    };
   const navigateAndUpdate= (userId) => {
        setClinicLoading(true) 
        dispatch(getClinicByID(userId))
        setClinicLoading(false)
        // Assuming you're using a routing library that provides a navigate function    
        navigate(`/crm/configuration/clinic/${userId}/services`);
    }

    const navigateAnd= () => {
          
        navigate(`/crm/user-manual`);
    }
    useEffect(() => {
        // Initialize Pusher
        const pusher = new Pusher('5e9dcc6e9cd79dc83685', {cluster: 'mt1'});

        // Subscribe to the specified channel
        const requestChannel = pusher.subscribe('new.request');

        // Bind to the 'subscription succeeded' event
        requestChannel.bind('pusher:subscription_succeeded', () => {
            //console.log('Successfully subscribed to the new.deployment channel.');
        });

        // Bind to the custom event
        requestChannel.bind("App\\Events\\NewRequestEvent", async (data) => {
            //console.log('NewDeploymentEvent received:', data);
            await dispatch(getUserDetails());
        });
    });
    const handleExploreServicesClick = () => {
        // Replace 'https://example.com' with the URL of the other app or website you want to redirect to
        window.location.href = user?.explore_services_url + "/#services";
    };


    return (
        <>
      <Box
  sx={{
    position: "relative",
    height: "69px",
    borderBottom: "1px solid #dee2e6",
    display: "flex",
    justifyContent:
      !setSidebarOpen || admin
        ? isCRM
          ? { xs: "space-between",  }
          : { xs: "space-between", }
        : "space-between",
    alignItems: "center",
  }}>
  < Box sx={{display:"flex"}}>
                            {!user?.id || user?.role_id === 1 ?  (
                        <Box>
                            <Button
                                variant="text"
                                sx={{
                                    ml:{sm:3, xs:'5px'},
                                    mr:'5px',
                                    backgroundColor: "#FAEFF5",
                                    display: {lg:'none',md:'none', xs:'block'},
                                    color: "#000",
                                    borderRadius: "7px",
                                    "&:hover": {
                                        backgroundColor: "#fff",
                                        border: "1px solid #A72C68",
                                        color: "#A72C68",
                                    },
                                }}
                                
                            >
                                <AdminDrawer/>
                            </Button>
                        </Box>
                    ) : (
                        ""
                    )}
                            {!user?.id || user?.role_id === 2 || user?.role_id === 4 ?  (
                        <Box>
                            <Button  
                                variant="text"
                                >
                                    <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={() => setMobileOpen(!mobileOpen)}
                sx={{ 
                    ml:{sm:3, xs:'5px'},                           
                    mr:'5px',
                    backgroundColor: "#FAEFF5",   
                    display: isCRM ? { lg: "none" } : { md: "none" },    
                    color: "#000",
                    borderRadius: "7px",   
                    "&:hover": {
                        backgroundColor: "#fff", 
                        border: "1px solid #A72C68",
                        color: "#A72C68",  
                    },
                }} 
            >
                <MenuIcon />
            </IconButton>
                            </Button>  
                        </Box>
                    ) : (
                        ""
                    )}
                                    {!user?.id || user?.role_id === 3 ?  (
                        <Box>
                            <Button variant="text">
                              
            <IconButton   
                color="inherit" 
                aria-label="open drawer"      
                edge="start"  
                onClick={() => setMobileOpen(!mobileOpen)}
                sx={{                  
                    ml:{sm:3, xs:'5px'},  
                    mr:'5px',
                    backgroundColor: "#FAEFF5",  
                    display: isCRM ? { lg: "none" } : { lg: "none" },
                    color: "#000",
                    borderRadius: "7px",
                    "&:hover": {  
                        backgroundColor: "#fff",     
                        border: "1px solid #A72C68",   
                        color: "#A72C68",
                    },
                }}

            >
                <MenuIcon />
            </IconButton>
                            </Button>  
                        </Box>
                    ) : (
                        ""
                    )}
                   
                   
    <Box
    sx={{
      position: admin ? "absolute" : "relative",
      top: admin ? "50%" : "auto",
      left: "10px",
      zIndex: "111",
      backgroundColor: "#FFFFFF",
      border: "1px solid #c4c4c4",
      borderRadius: "50%",
      padding: "4px",
      transition: ".5s",
      cursor: "pointer",
      display: setSidebarOpen
        ? isCRM
          ? { xs: "none", lg: "flex" }
          : { xs: "none", lg: "flex" }
        : "none",
      justifyContent: "center",
      alignItems: "center",
      transform: admin
        ? sidebarOpen
          ? "translateY(-50%)"
          : "translateY(-50%) rotate(540deg)"
        : sidebarOpen
          ? ""
          : "rotate(540deg)",
    }}
    onClick={() => setSidebarOpen(!sidebarOpen)}
  >
    <img src={arrowLeft} alt={"arrow"} />
  </Box>

  {/* New Box for Hello + Username */}
  <Box
    sx={{
      display: {lg:"flex",md:"flex", sm:"none", xs:"none"},
      alignItems: "center",
      ml: 2, // Optional margin to space out from the arrow
     
    }}
  >
    <Typography variant="body1" sx={{  alignItems: "center", fontSize: "20px", // Optional styling
      color: "#A72C68", // Optional styling
      fontWeight:800, }}>
      Hello {user?.name || "Guest"} 
    </Typography>
    <WavingHandIcon sx={{ml: 3, color:"#A72C68"}} />
  </Box>
  </Box>




            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                 
                }}
            >
                {isCRM && (
                    <Box sx={{ mr: { sm: 2, xs: 1 }, display: 'flex', alignItems: 'center' }}>
                        <NotificationsBell events={Event_report} />
                    </Box>
                )}
                {(user?.role_id === 2 || user?.is_reception === 1)  && (
                    <Box
                        sx={{
                            borderRight: "1px solid #dee2e6",  
                            borderLeft: "1px solid #dee2e6",
                            width: "60px",
                            height: "69px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center", 
                            cursor: "pointer",
                        }}
                        onClick={() => navigateAndUpdate(user?.role_id === 2 ? user?.id : user?.provider_id)}
                    >

                        <Tooltip title="Settings" arrow>

                        <SettingsIcon style={{ color:"#A72C68", fontSize: "2rem" }} />
                        </Tooltip>
                    </Box>
                )}
                 {user?.role_id === 2 && (  
                    <Box

                        sx={{  
                borderRight: "1px solid #dee2e6", 
                            borderLeft: "1px solid #dee2e6",
                            width: "60px",
                            height: "69px",
                            display: "flex",
                            alignItems: "center", 
                            justifyContent: "center", 
                            cursor: "pointer",
                            '@media (max-width: 350px) ': {
                            display:'none',
    },
                        }}           
                        onClick={() => navigateAnd()}
                    >  

                       <Tooltip title="Video Manuals" arrow>

        <OndemandVideoIcon style={{ color:"#A72C68", fontSize: "2rem" ,marginBottom:"5px"}} />
    </Tooltip>
                    </Box>
                )} 
                <Box  
                    sx={{
                        display: "flex",
                        alignItems: "center",   
                        justifyContent: "center",  
                        padding: {sm:'0 35px', xs:'0 5px'},
                    }}
                >
                    <Avatar
                        alt={user?.name}
                        src={user?.profile_image || undefined}
                        sx={{
                            background: user?.profile_image
                                ? undefined
                                : 'linear-gradient(135deg,#A72C68 0%,#7E1A4C 100%)',
                            color: '#fff',
                            fontWeight: 700,
                            fontSize: '16px',
                            border: '2px solid #FAEFF5',
                            boxShadow: '0 2px 8px rgba(167,44,104,0.25)',
                        }}
                    >
                        {(user?.name || 'U').trim().charAt(0).toUpperCase()}
                    </Avatar>
                    <Typography
                        as={"p"}
                        sx={{
                            ml: 1.5,
                            textTransform: "capitalize",
                            overflowWrap:'anywhere',
                            color: '#921F58',
                            fontWeight: 700,
                            "@media (max-width:319px)": {
                                fontSize:'12px'
                              },
                              display:{sm:"block",xs:"none"}

                        }}
                    >
                        {user?.name}
                    </Typography>
                    {!user?.id || user?.role_id == 3 ? (
                        <Box sx={{ display: { sm: "block", xs: "none" } }}>
                            <Button
                                variant="text"                      
                                sx={{
                                    background: "#E6DAD1",
                                    color: "#000",
                                    ml: 2,
                                    "&:hover": {
                                        background: "#E6DAD1 ",
                                    },
                                }}
                                onClick={handleExploreServicesClick}
                            >
                                Explore More Services
                            </Button>
                        </Box>
                    ) : (
                        ""
                    )}
                </Box>

                <Button
                    variant={"outlined"}
                    sx={{
                        height: "50px",
                        width: "50px",
                        borderRadius: '8px',
                        borderColor: "#FAEFF5",
                        backgroundColor: "#FAEFF5",
                        color: "#A72C68",
                        marginRight:'10px',
                        "&:hover": {
                            color: "#fff",
                            background: "#A72C68",
                            borderColor: "#A72C68",
                        },
                    }}
                    onClick={handleLogout}
                >
                    <MdPowerSettingsNew style={{ fontSize: "1.5rem" }} />
                </Button>
            </Box>

        </Box>
            {user?.role_id === 3 && user?.email_verified_at === null && (
                <Box
                    sx={{
                        background: "rgb(253, 237, 237)",
                        p: '7px',
                        my: 2,
                        borderRadius: '6px',
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignContent: 'center',
                            flexWrap: 'wrap',
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',

               //////////////////////////    fontFamily: "helvetica-lt-std-roman",
                            }}
                        >
                            <ErrorOutlineIcon style={{ color: 'red', marginRight: '10px' }} />
                            Your email is not verified — please check your email!
                        </Box>
                        <Box>
                            <Button
                                variant="contained"
                                sx={{
                                    background: '#E6DAD1',
                                    color: '#000',
                                    fontSize: { sm: '15px', xs: '10px' },
                                    mt: { sm: 0, xs: 2 },
                                    ml: { sm: 3, xs: 1 },
                                }}
                            >
                                Resend Verification Email
                            </Button>
                        </Box>
                    </Box>
                </Box>
            )}

        </>
    );
};

export default Header; 
